<template>
    <div class="input-group">
      <div class="input-group-prepend" v-if="isCurrency">
          <span class="input-group-addon">$</span>
      </div>
      <input 
        v-bind:type="type"
        class="form-control"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        v-bind:placeholder="placeholder"
        v-bind:class="{'is-invalid': hasError(), 'input-sm': isSmall()}"
        @keydown.enter="$emit('enter', $event)"
        @keydown.tab="$emit('tab', $event)"
        :readonly="readonly" />
      <div class="input-group-append" v-if="isPercent">
        <span class="input-group-addon">%</span>
      </div>
      <div class="form-invalid-feedback" v-if="hasError()">
        {{getError()}}
      </div>
      <span v-if="!hasError() && note" class="form-field-note">{{note}}</span>
    </div>
</template>

<script>
import formField from '@/mixins/formField'
import { UOMTypes } from '@/store/types'

export default {
  name: "FormInputStockPrice",
  mixins: [formField],
  props: {
    uomType: String,
    type: {
      type: String,
      default: 'number'
    },
    size: {
      type: String,
      default: 'regular'
    },
    value: [String, Number],
    placeholder: String,
    readonly: Boolean,
    field: String,
    note: String
  },
  watch: {
    value: function(newVal, oldVal) {
      // Default to empty string if null given
      if(newVal == null) {
        this.$nextTick(() => {
          this.$emit('input', '')
        })
      }
    }
  },
  computed: {
    isCurrency() {
      return !this.isPercent
    },
    isPercent() {
      return this.uomType == UOMTypes.percentOfLineItem || this.uomType == UOMTypes.percentOfOrder
    },
  },
  mounted() {
  },
  methods: {
    hasError() {
      return this.getFieldError(this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.field)
    },
    isSmall() {
      return this.size == 'small'
    }
  }
};
</script>